export class TableSorters {
    static sortString<T>(selector: (item: T) => string | null | undefined): (a: T, b: T) => number {
        return (a, b): number => (selector(a) ?? '').localeCompare(selector(b) ?? '');
    }

    static sortNumber<T>(selector: (item: T) => number | null | undefined): (a: T, b: T) => number {
        return (a, b): number => (selector(a) ?? 0) - (selector(b) ?? 0);
    }

    static sortDate<T>(selector: (item: T) => string | Date | null | undefined): (a: T, b: T) => number {
        return (a, b): number => {
            const left: string | Date = selector(a);
            const right: string | Date = selector(b);

            return this.toTime(left) - this.toTime(right);
        };
    }

    static sortBoolean<T>(selector: (item: T) => boolean | null | undefined): (a: T, b: T) => number {
        return (a, b): number => {
            const left = selector(a) ?? false;
            const right = selector(b) ?? false;

            return Number(left) - Number(right);
        };
    }

    private static toTime(value: string | Date | null | undefined): number {
        if (!value) {
            return 0;
        }

        return value instanceof Date ? value.getTime() : new Date(value).getTime();
    }
}
